import { ForwardedRef, forwardRef } from "react";
import { ItemLenguajesProps } from "./ItemLenguajes.types";
import { Text, View } from "reshaped";

export const ItemLenguajes = forwardRef(
  (props: ItemLenguajesProps, ref: ForwardedRef<HTMLDivElement>) => {
    const { technology, ...rest } = props;

    return (
      <div ref={ref} {...rest}>
        <View
          direction="column"
          padding={5}
          borderColor="neutral"
          borderRadius="medium"
          backgroundColor="disabled"
        >

          <Text variant="body-2" weight="bold" maxLines={2}>
            {technology.category}
          </Text>

          <Text variant="body-2">{technology.technologies.title}</Text>
        </View>
      </div>
    );
  }
);

